const defaultState = {
  ui: {}
};

export default function userPermissions(state = defaultState, action) {
  switch (action.type) {
    case 'SET_USER_PERMISSIONS':
      return {...state, ...action.payload};
    default:
      return state;
  }
}